import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import AuthProvider from "./contexts/AuthProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CoursesProvider } from "./contexts/CourseChapterProvider";
import { QueryClient, QueryClientProvider } from "react-query";
import { FetchProvider } from "./contexts/FetchProvider";
import { ReactQueryDevtools } from "react-query/devtools";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <FetchProvider>
          <AuthProvider>
            <CoursesProvider>
              <Provider store={store}>
                <Routes>
                  <Route path="/*" element={<App />} />
                </Routes>
              </Provider>
            </CoursesProvider>
          </AuthProvider>
        </FetchProvider>
      </BrowserRouter>
      <ReactQueryDevtools />
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
